import { Upload } from "antd";
import { RcFile } from "antd/lib/upload";
import { useTranslation } from "react-i18next";
import ActionTextIcon from "../../../../common/components/icons/ActionTextIcon";
import styles from "./DocumentNodeToolbarMenuView.module.scss";

interface Props {
  hasPermission: boolean;
  anyNodeSelected: boolean;
  onFilesUpload: (file: RcFile, fileList: RcFile[]) => boolean;
  onMoveNodesClick: () => void;
  onCreateFolderClick: () => void;
  onDeleteNodesClick: () => void;
}

export const DocumentNodeToolbarMenuView = ({
  hasPermission,
  anyNodeSelected,
  onFilesUpload,
  onMoveNodesClick,
  onCreateFolderClick,
  onDeleteNodesClick,
}: Props) => {
  const { t } = useTranslation();

  return (
    <div className={styles.documentsMenu}>
      <ul className={styles.documentsMenuBox}>
        {hasPermission ? (
          <>
            <li>
              <ActionTextIcon
                icon="new-folder"
                color="blue"
                text={t("documentNode.menu.createFolder")}
                onClick={onCreateFolderClick}
              />
            </li>

            <li>
              <Upload multiple beforeUpload={onFilesUpload} showUploadList={false}>
                <ActionTextIcon icon="cloud-upload" color="green" text={t("documentNode.menu.upload")} />
              </Upload>
            </li>

            <li>
              <ActionTextIcon
                icon="retweet"
                color="orange"
                text={t("documentNode.menu.move")}
                disabled={!anyNodeSelected}
                onClick={() => onMoveNodesClick()}
              />
            </li>

            <li>
              <ActionTextIcon
                icon="delete"
                color="red"
                text={t("documentNode.menu.delete")}
                disabled={!anyNodeSelected}
                onClick={() => onDeleteNodesClick()}
              />
            </li>
          </>
        ) : undefined}
      </ul>
    </div>
  );
};
